import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M12 3L2 20H22L12 3ZM12 18C11.45 18 11 17.55 11 17C11 16.45 11.45 16 12 16C12.55 16 13 16.45 13 17C13 17.55 12.55 18 12 18ZM12 15C11.45 15 11 14.55 11 13.99V10.01C11 9.45 11.45 9 12 9C12.55 9 13 9.45 13 10.01V13.99C13 14.55 12.55 15 12 15Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'ExclamationMarkTriangleFill');

export default Icon;
